import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from 'src/app/features/auth/services/auth.service';
import { LocalStorageService } from 'src/app/shared/localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInAuthGuard implements CanActivate {
  currentUrl!: string;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.getAuthStatus()) {
      try {
        this.router.navigate([LocalStorageService.get('currentUrl') || '/catalogs']);
        return false;
      } catch (e) {
        this.router.navigate(['/catalogs']);
        return false;
      }
    }
    return true;
  }
}
